<template>
  <div class="bg bg18">
    <div class="class--con">
      <class-but @forward="forward"/>
    </div>
  </div>
</template>

<script>
import ClassBut from "@/views/conference/ConferenceItem/classBut.vue";


export default {
  name: "contentImagination",
  components: {ClassBut},
  data() {
    return {}
  },
  methods: {
    forward() {
      this.$router.push({
        name: 'cutePets',
        query: this.$route.query,
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import "reportClass.less";
</style>
